import React from "react";
import { Modal, notification } from "antd"; // Import Modal from Ant Design
import { useRejectCandidates } from "utils";
import { SvgIcons } from "Icon/SvgIcons";

interface RejectCandidateProps {
    selectedPool: number | null;
    searchId?: number | string;
    isSelected?: boolean;
    handleRejectCandidate?: any;
    selectedCandidates: number;
}

const RejectCandidate: React.FC<RejectCandidateProps> = ({ selectedPool, selectedCandidates, searchId, isSelected, handleRejectCandidate }) => {
    const { rejectCandidates, loadingReject, error, success } = useRejectCandidates();

    const confirmRejectCandidates = () => {
        Modal.confirm({
            title: "Reject Candidates",
            content: "Are you sure you want to reject the selected candidates?",
            okText: "Yes",
            cancelText: "No",
            centered: true,
            onOk: handleRejectCandidates, // Call handleRejectCandidates if confirmed
        });
    };

    const handleRejectCandidates = async () => {
        if (selectedPool !== null && selectedCandidates) { 
            await rejectCandidates({ selectedPool, selectedCandidates, searchId, handleRejectCandidate });
        }
    };

    return (
        <button onClick={confirmRejectCandidates} className="w-12 h-10 rounded-md flex cursor-pointer items-center justify-center text-[#6941C6]">
          {isSelected ? SvgIcons.downThumbFilledIcon : SvgIcons.downThumbIcon}
        </button>
    );
};

export default RejectCandidate;
